import { useMutation } from "@apollo/client";
import { useState } from "react";

import { Button } from "../../../../../components/ui/Button";
import { CREATE_MAILING_LIST } from "../../../../../graphql/mutation/MailingList";

const CreateMailingList = ({ closeModal }) => {
  const [name, setName] = useState("");
  const [error, setError] = useState(null);
  const [createdName, setCreatedName] = useState(null);
  const [createMailingList, { loading }] = useMutation(CREATE_MAILING_LIST, {
    update: (cache, { data }) => {
      if (data?.createMailingList?.success) {
        cache.evict({ id: "ROOT_QUERY", fieldName: "mailingLists" });
      }
    },
  });

  const handleSubmit = async event => {
    event.preventDefault();
    if (loading || !name.trim()) return;
    setError(null);
    try {
      const { data } = await createMailingList({
        variables: { input: { description: name.trim() } },
      });
      const result = data?.createMailingList;
      if (!result?.success) {
        throw new Error(result?.error || "Failed to create mailing list");
      }
      setCreatedName(result.mailingList.description);
    } catch (error) {
      setError(error.message);
    }
  };

  if (createdName) {
    return (
      <div className="mt-4 space-y-4">
        <p role="status">Mailing list “{createdName}” created.</p>
        <p>Add contacts using Contacts → Update CRM → Mailing Lists.</p>
        <Button label="Done" onClick={closeModal} />
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="mt-4 space-y-4">
      <label className="block">
        <span className="mb-2 block text-sm font-medium">Mailing list name</span>
        <input
          data-autofocus
          className="w-full rounded border border-gray-300 px-3 py-2"
          value={name}
          onChange={event => setName(event.target.value)}
          maxLength={255}
          required
          disabled={loading}
        />
      </label>
      {error && (
        <p role="alert" className="text-sm text-red-600">
          {error}
        </p>
      )}
      <div className="flex justify-end gap-3">
        <Button label="Cancel" onClick={closeModal} disabled={loading} />
        <Button
          type="submit"
          label={loading ? "Creating…" : "Create Mailing List"}
          disabled={loading || !name.trim()}
        />
      </div>
    </form>
  );
};

export default CreateMailingList;
